export class BulkProductPriceModel{
 id:number;
 details:string;
 deviceCount:number;
 price:number;
 displayPrice:number;
 duration:number;
 amount:number;
 bulkCount:number;
}